import React from "react";
import styled from "styled-components";

const Container = styled.div`
  color: #fff;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  background-color: #ffcc00;
  border-radius: 4px;
  padding: 2px 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

function BadgeEsgotado() {
  return <Container>PRÉ-VENDA</Container>;
}

export default BadgeEsgotado;
